import _ from 'lodash';
import { getOrders } from '../selectors';

export const hasUnsyncedOrder = (orders) => {
  for (let i = 0; i < orders.length; i++) {
    const o = orders[i];
    if (_.isNil(o) || _.isNil(o.doc)) {
      continue;
    }

    if (o.doc.status === 'draft' && !_.isNil(o.doc.orderType)) {
      return true;
    }
  }

  return false;
};

export const getStatusNotification = (context) => {
  const orders = getOrders(context);
  const openOrder = hasUnsyncedOrder(orders);
  const isOffline = !context.state.online;
  const hasNotifications = openOrder || isOffline;
  return { hasNotifications, isOffline, openOrder };
};
